import { render, staticRenderFns } from "./BranchesImport.vue?vue&type=template&id=24392e78&"
import script from "./BranchesImport.vue?vue&type=script&lang=js&"
export * from "./BranchesImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports